import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { Box, BoxProps } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { varSmallClick, varMediumClick } from './variants';

interface ButtonAnimateProps extends Omit<BoxProps, 'sx'> {
  mediumClick?: boolean;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

export default function ButtonAnimate({
  mediumClick = false,
  children,
  sx,
  ...other
}: ButtonAnimateProps) {
  return (
    <Box
      component={motion.div}
      whileTap="tap"
      whileHover="hover"
      variants={mediumClick ? varMediumClick : varSmallClick}
      sx={{ display: 'inline-flex', ...(sx as object) }}
      {...other}
    >
      {children}
    </Box>
  );
}